import React from 'react';
import BreadcrumbsTwoLayers from '../../shared/heading/BreadcrumbsTwoLayers';
import { SETTINGS_URL } from '../../shared/UrlMap';

const BreadcrumbInHeader = ({ subName, extraLayer }: { subName: string; extraLayer?: React.ReactNode }) => {
  return <BreadcrumbsTwoLayers name={'Settings'} subName={subName} url={SETTINGS_URL} extraLayer={extraLayer} />;
};

export default BreadcrumbInHeader;
